/**
 * loader creates the window.toggleLoader and window.isLoading function.
 *
 * window.toggleLoader toggles the class 'is-active' on the loader element based on the given state.
 * - on: Boolean          (State to toggle the loader to)
 *
 * window.isLoading returns whether or not the loader modal is visible. This is helpful when deciding whether to execute a function or not.
 *
 * Dependencies
 * - the loader partial in materials/partials
 */

function loader () {
	const loaderSelector = '#loaderModal';

	const isActiveClass = 'is-active';

	window.toggleLoader = function (on) {
		if (on) {
			$(loaderSelector).addClass(isActiveClass);
		} else {
			$(loaderSelector).removeClass(isActiveClass);
		}
	};

	window.isLoading = function () {
		return $(loaderSelector).hasClass(isActiveClass);
	};
}
loader();
